import { Link, Outlet, createRootRouteWithContext } from "@tanstack/react-router";

import type { QueryClient } from "@tanstack/react-query";
import { ErrorFallback } from "@/components/feedback/error-fallback";
import type { AuthContext } from "@/features/auth/auth-types";

interface RouterContext {
  queryClient: QueryClient;
  auth: AuthContext;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  // 最後の砦の errorComponent（FE-7）。`/` の beforeLoad/loader で投げた場合に、
  // router の reset/再試行が効く形でフォールバックを出す（外側の素の ErrorBoundary より統合的）。
  errorComponent: ({ error, reset }) => (
    <ErrorFallback
      error={error instanceof Error ? error : new Error(String(error))}
      onReset={reset}
      variant="page"
    />
  ),
  notFoundComponent: () => (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-surface-off-white">
      <h1 className="text-4xl font-bold text-brand-primary">404</h1>
      <p className="text-brand-gray-700">お探しのページは見つかりませんでした</p>
      <Link to="/" className="text-brand-primary underline">
        トップへ戻る
      </Link>
    </div>
  ),
});

function RootLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}
